<!--  设备状态告警组件 -->
<template>
  <div style="height: 100%">
    <div class="record">
      <div class="title_box">
        <div class="new_title">{{ $t('EquipmentStatusAlarm') }}</div>
      </div>
      <div class="check_more" v-if="healthyData.length > 6" @click="showMore(mainTitle.statusTitle, '', 'device')">
        {{ $t('SeeMore') }}>
      </div>
    </div>
    <div class="healthy_alarm">
      <div class="in_out">
        <ul v-if="healthyData.length > 0">
          <li v-for="(item, index) in healthyData" :key="index">
            <span class="li_icon"></span>
            <el-tooltip effect="dark" :content="item.content" placement="top-start">
              <span
                ><span>{{ item.userName }}-</span>
                <span>{{ item.helmetId }}-</span>
                <span class="alarm_event">{{ item.event }}</span>
                <span>-{{ item.logTimestamp }}</span></span
              >
            </el-tooltip>
          </li>
        </ul>
        <div v-else class="empty">{{ $t('AllDevicesNormal') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { healthStatus } from '@/api/new-device/newDevice'
import { formatDate, nowDate } from '@/util/date'
export default {
  props: {
    currenNode: {
      type: Object / Array,
    },
  },
  data() {
    return {
      healthyData: [],
      searchPage: { pageSize: 10, pageNum: 1 },
      mainTitle: { dynamicTitle: this.$t('RemainingPowerEquipment'), statusTitle: this.$t('EquipmentStatusAlarm') },
    }
  },
  methods: {
    showMore() {
      this.$emit('showMore')
    },
    // 设备状态分析
    gethealthStatus() {
      let logDateEnd
      // 查询结束时间不能为空
      if (this.currenNode.endTime === null) {
        // 如果为空，获取当天日期
        logDateEnd = nowDate()
      } else {
        logDateEnd = formatDate(this.currenNode.endTime)
      }
      let param = {
        ouId: this.currenNode.id,
        logDateBegin: formatDate(this.currenNode.startTime),
        logDateEnd: logDateEnd,
        pageSize: this.searchPage.pageSize,
        pageNum: this.searchPage.pageNum,
      }
      healthStatus(param).then(res => {
        if (res.state === 0) {
          this.healthyData = []
          for (let item of res.value.content) {
            if (item.event === 0) {
              item.event = this.$t('CPUtemperatureexceed')
            } else if (item.event === 1) {
              item.event = this.$t('Remainingmemorybelow')
            } else if (item.event === 2) {
              item.event = this.$t('RemainingStorageLess')
            } else if (item.event === 3) {
              item.event = this.$t('remainingPowerLess')
            } else if (item.event === 4) {
              item.event = this.$t('batteryTempLow') + (item.abnormalData ? (item.abnormalData + '℃') : '')
            } else if (item.event === 5) {
              item.event = this.$t('batteryTempHigh') + (item.abnormalData ? (item.abnormalData + '℃') : '')
            }
            item.content = item.userName + item.helmetId + item.event + item.logTimestamp
            this.healthyData.push(item)
          }
        }
      })
    },
  },
  watch: {
    currenNode: {
      handler(val) {
        // 查询不同租户触发请求数据
        if (this.currenNode.id !== '') {
          this.gethealthStatus()
        }
      },
      deep: true,
    },
  },
  computed: {},
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.record
  position relative
  .check_more
    position: absolute
    right: 15px
    top 50%
    transform: translate(0,-50%)
    text-align: center
    line-height: 28px
    padding: 0 7px

    border-radius: 2px
    font-weight: bold

    font-size: 14px
    border-radius: 4px;
    cursor pointer
.title_box
  .new_title
    height 46px
    line-height 46px
    padding-left 56px
    font-size: 18px;
    font-weight: bold
.healthy_alarm
  height: calc(100% - 60px)
  width: 92%
  margin-left: 26px
  margin-top: 6px
  line-height: 26px
  .in_out
    height: 100%
  ul
    height: 100%
    width: 100%
    overflow: auto
    margin-top 10px
    li
      width: 100%
      white-space: nowrap;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis
      cursor default!important
      .li_icon
        display inline-block
        width: 8px;/*no*/
        height: 8px;/*no*/
        background: #FF3F63
        margin-right: 10px
      .alarm_event
        color: #FF3F63
      .occur_time
        margin-right: 10px
  .empty
    font-size: 16px
    color: #0E8BFF
    text-align: center
    line-height: 60px
</style>
